module.exports = __webpack_public_path__ + "static/media/btn_etikett_mit_ankleber.4cede3a7.png";